export default __webpack_public_path__ + "assets/png/9fba3aa6248039e53b4d26133f1ff3d5.png";